import React from 'react';
import { LinearProgressWithLabel } from '../../../components/Modals/OI Modal/functions';
import { Typography } from '@material-ui/core';

const WatchListLoading = () => {
  return (
    <div style={{ paddingTop: '50px' }}>
      <LinearProgressWithLabel />

      <Typography
        variant="body2"
        color="secondary"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        Please standby. Retrieving the data...
      </Typography>
    </div>
  );
};
export default WatchListLoading;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/components/WatchListLoading.jsx